import React from "react";
import { Route } from "react-router-dom";
import {
  AuthenticatedApp,
  AuthenticatedSwitch,
  PrivateRoute,
  PublicRoute,
  NavigationLogger,
  ResponsiveScreen,
} from "@redriver/cinnamon";
import { EnvironmentBanner } from "components/banners";
import { AppRoutes, SystemRoutes } from "constants/routes";
import LoginPage from "./system/LoginPage";
import AzureSsoSignInPage from "./system/AzureSsoSignInPage";
import AuthenticationPage from "./system/AuthenticationPage";
import LogoutPage from "./system/LogoutPage";
import UserSetupPage from "./system/UserSetupPage";
import EmailVerificationPage from "./system/EmailVerificationPage";
import PasswordForgottenPage from "./system/PasswordForgottenPage";
import PasswordResetPage from "./system/PasswordResetPage";
import MagicLinkSignInPage from "./system/MagicLinkSignInPage";
import SharedFilePage from "./SharedFilePage";
import MaplesTeesdale from "./MaplesTeesdale";
import "styles/index.scss";

/**
 * Top-level app routes only
 * Define sub-path routes inside top-level page components
 */
const Shell = () => (
  <AuthenticatedApp>
    <NavigationLogger />
    <ResponsiveScreen />
    <EnvironmentBanner />
    <AuthenticatedSwitch>
      {/* system routes */}
      <Route exact path={SystemRoutes.Login} component={LoginPage} />
      <Route
        exact
        path={SystemRoutes.AzureAdSignIn}
        component={AzureSsoSignInPage}
      />
      <Route
        exact
        path={SystemRoutes.Authenticate}
        component={AuthenticationPage}
      />
      <Route exact path={SystemRoutes.Logout} component={LogoutPage} />
      <Route exact path={SystemRoutes.SetupUser} component={UserSetupPage} />
      <Route
        exact
        path={SystemRoutes.VerifyEmail}
        component={EmailVerificationPage}
      />
      <PublicRoute
        exact
        path={SystemRoutes.ForgottenPassword}
        component={PasswordForgottenPage}
      />
      <PublicRoute
        exact
        path={SystemRoutes.ResetPassword}
        component={PasswordResetPage}
      />
      <PublicRoute
        exact
        path={SystemRoutes.MagicLinkSignIn}
        component={MagicLinkSignInPage}
      />
      <Route exact path={AppRoutes.SharedFile()} component={SharedFilePage} />

      {/* app routes */}
      <PrivateRoute component={MaplesTeesdale} redirect={SystemRoutes.Login} />
    </AuthenticatedSwitch>
  </AuthenticatedApp>
);

export default Shell;
